document.addEventListener('turbolinks:load', () => {

  var customer_id = gon.customer_id;
  $(function(){
    $('#customer_tabs_sales').on('click',function(e){
      e.preventDefault();
      $.ajax({
        url: '/customers/sales', 
        type: 'GET',
        dataType: "html",
        data:{
            id: customer_id
        },
      }).done((response) => {
        // console.log(response)
        r = document.getElementById('customer_sales')
        r.innerHTML = response
      }).fail((err) => {
        // console.log(err);
      })
    });
  });

});

// var item_clip = document.getElementById('item_clip')
// if(item_clip){
//   item_clip.addEventListener("click", function() {
  $(document).on('click', '#item_clip',function(e){
      var item_id = gon.item_id;

      $.ajax({
        url: `/clips/${item_id}/create`, 
        // url: `/clips/create`, 
        type: 'POST',
        dataType: "script",
        data:{
            id: item_id
        },
      }).done((response) => {

        r = document.getElementById('item_clip_badge')
        r.innerHTML = ""
        r.innerHTML = response
      }).fail((err) => {
        console.log(err);
      })
    })

//   var item_unclip = document.getElementById('item_unclip')

// if(item_unclip){
  
//   item_unclip.addEventListener("click", function(){
    $(document).on('click', '#item_unclip',function(e){
      e.preventDefault();
      var item_id = gon.item_id;
      $.ajax({
        url: `/clips/${item_id}/destroy`, 
        // url: `/clips/destroy`, 
        type: 'POST',
        dataType: "script",
        data:{
            id: item_id
        },
      }).done((response) => {

        r = document.getElementById('item_clip_badge')
        r.innerHTML = ""
        r.innerHTML = response
      }).fail((err) => {
        console.log(err);
      })
    })

  // }

$(document).on('click', '#sale_clip',function(e){
  e.preventDefault();
  var sale_id = gon.sale_id;
  // console.log("clicked")
  $.ajax({
    url: `/sale_clips/${sale_id}/create`, 
    // url: `/sale_clips/create`, 
    type: 'POST',
    dataType: "script",
    // data:{
    //     id: sale_id
    // },
  }).done((response) => {
    //  response.preventDefault();
    //  console.log(response)
    r = document.getElementById('sale_clip_badge')
    r.innerHTML = ""
    r.innerHTML = response
  }).fail((err) => {
    // console.log(err);
  })
})

$(document).on('click', '#sale_unclip',function(e){
  e.preventDefault();
  var sale_id = gon.sale_id;

  $.ajax({
    url: `/sale_clips/${sale_id}/destroy`, 
    // url: `/sale_clips/destroy`, 
    type: 'POST',
    dataType: "script",
    // data:{
    //     id: sale_id
    // },
  }).done((response) => {
    // response.preventDefault();
    // console.log(response)
    r = document.getElementById('sale_clip_badge')
    r.innerHTML = ""
    r.innerHTML = response
  }).fail((err) => {
    // console.log(err);
  })
})
